/**
 * Emoji representativo da atividade psicomotora — placeholder reconhecível quando
 * ainda não há foto/clipe real (sobretudo no modo criança, onde a imagem comunica).
 * Mapa por nome (materiais e jogos comuns); cai pro tipo da atividade.
 */
import type { TipoAtividade } from "./types";

const semAcento = (s: string) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

const POR_NOME: Record<string, string> = {
  "cama elastica": "🤸",
  trampolim: "🤸",
  pular: "🤸",
  pulo: "🤸",
  tunel: "🛝",
  rastejar: "🐛",
  espelho: "🪞",
  estatua: "🗿",
  circuito: "🛤️",
  tapete: "🧩",
  balanco: "🪂",
  gangorra: "🛝",
  bola: "⚽",
  pilates: "⚽",
  almofada: "🛋️",
  almofadas: "🛋️",
  empurrar: "💪",
  puxar: "💪",
  danca: "💃",
  dancar: "💃",
  imitar: "🪞",
  esconde: "🙈",
  "esconde-esconde": "🙈",
  amarelinha: "🔢",
  pular_corda: "🪢",
  corda: "🪢",
  massinha: "🫳",
  amassar: "🫳",
  argila: "🫳",
  cambalhota: "🤸",
  rolar: "🌀",
  girar: "🌀",
  equilibrio: "⚖️",
  caminhar: "🚶",
  correr: "🏃",
  engatinhar: "🐛",
  escalar: "🧗",
  arco: "⭕",
  bambole: "⭕",
};

const POR_TIPO: Record<TipoAtividade, string> = {
  jogo: "🎯",
  circuito: "🛤️",
  material: "🧩",
  exercicio: "💪",
  brincadeira: "🤾",
};

export function emojiAtividade(
  nome?: string | null,
  tipo?: TipoAtividade | null,
): string {
  if (nome) {
    const n = semAcento(nome);
    if (POR_NOME[n]) return POR_NOME[n];
    for (const palavra of n.split(/\s+/)) {
      if (POR_NOME[palavra]) return POR_NOME[palavra];
    }
  }
  if (tipo && POR_TIPO[tipo]) return POR_TIPO[tipo];
  return "🤸";
}
